import { DropdownOption, PrescriberNameObject } from '../types/dropdownFilter';

export function stringsToDropdownOptions(options: string[], formatFn?: (option: string) => string) {
  return options.map((option) => ({ value: option, description: formatFn ? formatFn(option) : option }));
}

export const formatDrugName = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const prescriberNamesToDropdownOptions = (names: PrescriberNameObject[]) => {
  return names.map((item) => {
    return {
      value: item.npi,
      description: item.name,
    } as DropdownOption;
  });
};
